import { getDynamicLSKey } from './getDynamicLSKey.js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const removeFromLS = (key) => {
    if (typeof window === 'undefined') {
        return undefined;
    }
    return window.localStorage.removeItem(getDynamicLSKey(key));
};

export { removeFromLS };
